import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sent, setSent] = useState(false);
  const [logoWhiteSvg, setLogoWhiteSvg] = useState(null);

  useEffect(() => {
    document.title = "Contact - Slimmer af";
  }, []);

  useEffect(() => {
    fetch("/logo-name-white.svg")
      .then((r) => r.text())
      .then((text) => {
        const scaled = text.replace(
          /<svg([^>]*)>/,
          (match) => {
            let attrs = match
              .replace(/\swidth="[^"]*"/, ' width="100%"')
              .replace(/\sheight="[^"]*"/, ' height="100%"');
            if (!/width=/.test(attrs)) attrs = attrs.replace(/<svg/, '<svg width="100%"');
            if (!/height=/.test(attrs)) attrs = attrs.replace(/<svg\s/, '<svg height="100%" ');
            return attrs.replace(/>$/, ' preserveAspectRatio="xMidYMid meet" style="display:block">');
          }
        );
        setLogoWhiteSvg(scaled);
      })
      .catch(() => {});
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !message.trim()) return;
    setSent(true);
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #3399FF 0%, #2288dd 100%)", position: "relative" }}>
      <div style={{ padding: "32px 20px 100px 20px", position: "relative" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 32 }}>
          <Link to="/" style={{ color: "#fff", textDecoration: "none", fontSize: 18, fontWeight: 500 }}>
            ← Terug
          </Link>
        </div>
        <div style={{ textAlign: "center", margin: 0 }}>
          {logoWhiteSvg ? (
            <div style={{ height: 48, width: 180, margin: "0 auto", display: "block" }} dangerouslySetInnerHTML={{ __html: logoWhiteSvg }} aria-hidden="true" />
          ) : (
            <img src="/logo-name-white.svg" alt="Slimmer af" style={{ height: 48, width: "auto", display: "block", margin: "0 auto" }} />
          )}
        </div>
      </div>

      <div style={{ padding: "0 clamp(16px, 5vw, 32px)", position: "relative", zIndex: 1 }}>
        <div style={{
          background: "#fff",
          borderRadius: 28,
          marginTop: "-56px",
          marginLeft: "auto",
          marginRight: "auto",
          width: "100%",
          maxWidth: 440,
          padding: "40px 24px",
          position: "relative",
          boxSizing: "border-box"
        }}>
          <div style={{ width: "100%", maxWidth: 420, margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 32 }}>
              <h2 style={{ marginTop: 0, marginBottom: 8, fontSize: 28, fontWeight: 700, color: "#1f2937" }}>
                Contact
              </h2>
              <p style={{ color: "#6b7280", fontSize: 15, margin: 0 }}>
                Stel je vraag en we nemen zo snel mogelijk contact met je op.
              </p>
            </div>

            {sent ? (
              <div style={{
                padding: 24,
                background: "#f0fdf4",
                border: "1px solid #bbf7d0",
                borderRadius: 12,
                color: "#166534",
                fontSize: 15,
                textAlign: "center"
              }}>
                Bedankt! We hebben je bericht ontvangen en nemen binnenkort contact met je op.
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: "block", fontSize: 13, color: "#6b7280", marginBottom: 8, fontWeight: 500 }}>Naam *</label>
                  <input
                    type="text"
                    placeholder="Je naam"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                    style={{ width: "100%", padding: "16px", borderRadius: 12, border: "1px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 15, boxSizing: "border-box" }}
                  />
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={{ display: "block", fontSize: 13, color: "#6b7280", marginBottom: 8, fontWeight: 500 }}>E-mailadres *</label>
                  <input
                    type="email"
                    placeholder="voorbeeld@email.nl"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{ width: "100%", padding: "16px", borderRadius: 12, border: "1px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 15, boxSizing: "border-box" }}
                  />
                </div>
                <div style={{ marginBottom: 24 }}>
                  <label style={{ display: "block", fontSize: 13, color: "#6b7280", marginBottom: 8, fontWeight: 500 }}>Je vraag *</label>
                  <textarea
                    placeholder="Schrijf hier je vraag..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    rows={5}
                    style={{ width: "100%", padding: "16px", borderRadius: 12, border: "1px solid #e5e7eb", background: "#fff", color: "#374151", fontSize: 15, boxSizing: "border-box", resize: "vertical", minHeight: 120 }}
                  />
                </div>
                <button
                  type="submit"
                  style={{
                    width: "100%",
                    padding: "16px",
                    borderRadius: 12,
                    background: "linear-gradient(135deg, #3399FF 0%, #2288dd 100%)",
                    color: "#fff",
                    border: "none",
                    fontSize: 16,
                    fontWeight: 600,
                    cursor: "pointer",
                    boxShadow: "0 2px 8px rgba(51,153,255,0.3)"
                  }}
                >
                  Verstuur vraag
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
